export const goodDialogFromIntents = [
  'CheckInTime',
  'CheckOutTime',
  'EarlyCheckIn',
  'HotelQuestions',
  'LateCheckout',
  'PriceCheck',
  'ShuttleRequest',
  'WrongName',
  'NextTravelDate'
]

export const dialogFlowIntentNames = {
  CheckInTime: 'Check-in time',
  CheckOutTime: 'Check-out time',
  EarlyCheckIn: 'Early check-in',
  HotelQuestions: 'Hotel questions',
  LateCheckout: 'Late check-out',
  PriceCheck: 'Price check',
  ShuttleRequest: 'Shuttle request',
  WrongName: 'Wrong name',
  NextTravelDate: 'Next travel date'
}

export const dialogFlowIntentNamesLowerCaseKeys = Object.keys(
  dialogFlowIntentNames
).reduce(
  (prev, curr) => ({ ...prev, [curr.toLocaleLowerCase()]: dialogFlowIntentNames[curr] }),
  {}
)
